const Actions = {
  CancelConfirm: 'CancelConfirm',
  CreateForm: 'CreateForm',
  EditForm: 'EditForm',
  Destructive: 'Destructive'
} as const

export const ActionStatus = {
  Success: 'success',
  Error: 'error',
  Pending: 'pending'
} as const

export default Actions
